import { CartItem } from './app.models';

export class UpdateProfileAction {
  static readonly type = '[FMLA] Login';
  constructor(public profile: any) {}
}

export class LogoutAction {
  static readonly type = '[FMLA] Logout';
  constructor() {}
}

export class AddItemToCart {
  static readonly type = '[FMLA] AddItemToCart';
  constructor(public item: CartItem) {}
}

export class RemoveItemFromCart {
  static readonly type = '[FMLA] RemoveItemFromCart';
  constructor(public item: CartItem) {}
}

export class RemoveAllItemsFromCart {
  static readonly type = '[FMLA] RemoveAllItemsFromCart';
  constructor() {}
}

export class UpdateItemInCart {
  static readonly type = '[FMLA] UpdateItemInCart';
  constructor(public item: CartItem, public quantity: number) {}
}

export class UpdateSelectedEventMonth {
  static readonly type = '[FMLA] UpdateSelectedMonth';
  constructor(public month: string) {}
}

export class UpdateSelectedMerchantCategory {
  static readonly type = '[FMLA] UpdateSelectedMerchantCategory';
  constructor(public categoryName: string, public subCategoryName: string) {}
}

export class UpdateSelectedStoreCategory {
  static readonly type = '[FMLA] UpdateSelectedStoreCategory';

  constructor(public categoryName: string) {}
}

export class UpdateSelectedNewsCategory {
  static readonly type = '[FMLA] UpdateSelectedNewsCategory';
  constructor(public categoryId: string) {}
}
